export default __webpack_public_path__ + "static/media/certificateeng.561e905c.png";